import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloGroupCarac, cleanAloGroupCarac } from '@/models/alo/AloGroupCarac'

export default {
  getAllGroupCarac(): AxiosPromise<AlrContainer<Array<AloGroupCarac>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/GroupCarac`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloGroupCarac>>
      }]
    })
  },
  getGroupCarac(id:number):AxiosPromise<AlrContainer<AloGroupCarac>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/GroupCarac/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloGroupCarac>
      }]
    })
  },
  saveGroupCarac(groupCarac:AloGroupCarac):AxiosPromise<AlrContainer<AloGroupCarac>> {
    cleanAloGroupCarac(groupCarac)
    if(groupCarac.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/GroupCarac`, 
        method: 'PUT',
        data: groupCarac,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloGroupCarac>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/GroupCarac`, 
        method: 'POST',
        data: groupCarac,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloGroupCarac>
        }]
      })    
    }
  },
  deleteGroupCarac(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/GroupCarac/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloGroupCarac>
      }]
    })
  }
}